import { render, staticRenderFns } from "./EmployeeHistoryTab.vue?vue&type=template&id=330127f4&scoped=true"
import script from "./EmployeeHistoryTab.vue?vue&type=script&lang=js"
export * from "./EmployeeHistoryTab.vue?vue&type=script&lang=js"
import style0 from "./EmployeeHistoryTab.vue?vue&type=style&index=0&id=330127f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330127f4",
  null
  
)

export default component.exports